import useMediaQuery from '@mui/material/useMediaQuery';

const MIN_WIDE_VIEWPORT_WIDTH_PX = 1024;

export interface DeviceState {
  isCoarsePointer: boolean;
  isNarrow: boolean;
  isWide: boolean;
}

/* v8 ignore next -- @preserve */
// Currently no way to configure vitest to simulate different devices or media queries * /
export function useDeviceState(): DeviceState {
  const isCoarsePointer = useMediaQuery('(pointer:coarse)');
  const isWide = useMediaQuery(`(min-width: ${MIN_WIDE_VIEWPORT_WIDTH_PX}px)`);
  const isNarrow = !isWide;
  return {isCoarsePointer, isNarrow, isWide};
}
